import { Row, Col, Modal, DatePicker, message } from "antd";
import { CalendarOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import wallet from "../../../../assets/images/wallet.svg";
import DeleteProduct from "../../../../assets/images/delete1.svg";
import styles from "../../../../constants/styles.json";
import useCartStore from "../../../../stores/useCartStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import useAuthStore from "../../../../stores/useAuthStore";

export const renderCustomerWallet = ({ posConfig, cartObj, matchedSaleType, fetchWalletData }) => {
  if (posConfig?.enable_customer_wallet !== "Y") return null;

  const hasCustomer = cartObj?.customer?.cwrCustomerId && cartObj?.customer?.cwrCustomerId !== matchedSaleType;
  const hasMobile = cartObj?.customer?.mobileNo !== null && cartObj?.customer?.mobileNo !== undefined;
  const selectedCustomer = hasCustomer && hasMobile;

  return (
    <Col
      onClick={() => {
        if (!hasCustomer) {
          message.warning("Please select a customer to proceed with Wallet");
          return;
        }
        if (!hasMobile) {
          message.warning("Please update customer mobile number to proceed with Wallet");
          return;
        }
        if (selectedCustomer) {
          fetchWalletData(false);
        }
      }}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        marginBottom: "2vh",
      }}
      span={22}
    >
      <img
        src={wallet}
        style={{
          height: "2.5vh",
          filter: !selectedCustomer ? "grayscale(100%)" : "none",
        }}
        alt=""
      />
      <span
        style={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "1.2em",
          paddingLeft: "1vw",
          color: "#0F0718",
        }}
      >
        Customer Wallet
      </span>
    </Col>
  );
};

export const renderExchangeDiv = ({ cart, currenciesList, pricePrecision }) => {
  const returnCart = useCartStore.getState().cart;
  const exchangeCart = useCartStore.getState().exchangeCart || {};

  const returnTotal = parseFloat(returnCart?.total || 0);
  const exchangeTotal = parseFloat(exchangeCart?.total || 0);

  const netValue = parseFloat((returnTotal + exchangeTotal).toFixed(pricePrecision));
  return (
    <>
      <Row style={{ height: "4.5vh" }}>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "0.8vw",
            textAlign: "left",
            fontWeight: "500",
            color: "#0F0718",
          }}
        >
          <p style={styles.screenStyles.mainScreen.subTotalText}>Old Value (Return):</p>
        </Col>
        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          &nbsp;
          <p
            style={{
              textAlign: "right",
              margin: "0",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            {parseFloat(returnCart?.total ?? cart?.total).toFixed(pricePrecision)}
          </p>
          <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
        </Col>
      </Row>
      <Row style={{ height: "4.5vh" }}>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "0.8vw",
            textAlign: "left",
            fontWeight: "500",
            color: "#0F0718",
          }}
        >
          <p style={styles.screenStyles.mainScreen.subTotalText}>New Value (Exchange):</p>
        </Col>
        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          &nbsp;
          <p
            style={{
              textAlign: "right",
              margin: "0",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            {parseFloat(exchangeCart?.total ?? 0).toFixed(pricePrecision)}
          </p>
          <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
        </Col>
      </Row>
      <Row style={{ height: "4.5vh" }}>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "0.8vw",
            textAlign: "left",
            fontWeight: "500",
            color: "#0F0718",
          }}
        >
          <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
        </Col>
        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          &nbsp;
          <p
            style={{
              textAlign: "right",
              margin: "0",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            {netValue}
          </p>
          <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
        </Col>
      </Row>
      <Row style={{ height: "4.5vh" }}>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "0.8vw",
            textAlign: "left",
            fontWeight: "500",
            color: "#0F0718",
          }}
        >
          <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items:</p>
        </Col>
        <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
          &nbsp;
          <p
            style={{
              textAlign: "right",
              margin: "0",
              fontWeight: "500",
              color: "#0F0718",
            }}
          >
            {exchangeCart?.items?.length || 0} / {parseFloat(exchangeCart?.totalQty || 0).toFixed(3)}
          </p>
        </Col>
      </Row>
    </>
  );
};

export const renderPaymentsData = ({ cart, isExchange, currenciesList, pricePrecision, handleDeletePayment }) => {
  const exchangeCartObj = useCartStore.getState().exchangeCart;
  const payments = isExchange ? exchangeCartObj?.payments : cart.payments;

  return payments?.map((item, idx) => {
    return (
      <Row key={item.name ? `${item.name}-${idx}` : idx} style={{ fontSize: "1vw" }}>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "0.8vw",
            fontWeight: "450",
            textAlign: "left",
          }}
        >
          <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" && item.authorization ? `${item.name} - ${item.authorization}` : item.name}</p>
        </Col>
        <Col
          span={12}
          style={{
            display: "flex",
            alignItems: "center",
            paddingRight: "1vw",
            textAlign: "right",
            justifyContent: "end",
          }}
        >
          <p
            style={{
              textAlign: "right",
              margin: "0",
              fontWeight: "500",
              paddingRight: "1.2vw",
            }}
          >
            {" "}
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
          </p>
          <img
            src={DeleteProduct}
            onClick={() => handleDeletePayment(item)}
            id="sm-product-delete"
            style={{
              height: "2.5vh",
              cursor: "pointer",
              right: 1,
              top: "15%",
            }}
          />
        </Col>
      </Row>
    );
  });
};

export const renderDeliveryDate = ({ cart }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        padding: "3px 6px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        color: "white",
        cursor: "pointer",
        width: "fit-content",
      }}
    >
      <CalendarOutlined
        style={{
          fontSize: "0.85rem",
          cursor: "pointer",
          paddingBottom: "0.1em",
        }}
      />
      <span style={{ fontSize: "0.7rem" }}>{cart?.deliveryDate || "Delivery Date"}</span>
    </div>
  );
};

export const watermark = ({ cart, posConfig }) => {
  const receiptlessReturn2Enabled = posConfig?.enableReceiptlessReturn2 === "Y";
  const returnEnabled = receiptlessReturn2Enabled && cart?.isReturn === true && cart?.isBlindReceipt === true;
  if (useTransactionStore.getState().selectedReturnType !== "EXCHANGE") {
    return (
      <div
        style={{
          position: "absolute",
          top: "57%",
          left: "30%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "",
          height: "54px",
          zIndex: 10,
        }}
      >
        <span
          style={{
            fontFamily: "Montserrat",
            fontWeight: "bold",
            fontSize: "50px",
            color: "#000",
            textAlign: "center",
            opacity: "10%",
          }}
        >
          {returnEnabled ? "RETURN" : posConfig?.showDocNoOnPOS === "Y" ? "ORDER" : posConfig?.allowLayawaywithoutPayment === "Y" && cart?.layAway === "Y" ? "LAYAWAY" : "INVOICE"}
        </span>
      </div>
    );
  }
};

export const showConfirm = ({ cart, amount, pricePrecision, posConfig, overPayedAmount }) => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: (
        <>
          <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
        </>
      ),
      icon: null,
      content: (
        <div
          style={{
            background: "#fff",
            height: "auto",
            width: "100%",
            border: "1px solid #fff",
            borderRadius: "7px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Bill Amount Row */}
          <Row
            style={{
              fontSize: "1em",
              width: "100%",
            }}
          >
            <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
              <p>Bill Amount</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontWeight: "400",
                  color: "#0F0718",
                }}
              >
                {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
              </p>
            </Col>
          </Row>

          {/* Amount Tendered Row */}
          <Row
            style={{
              fontSize: "1em",
              width: "100%",
            }}
          >
            <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
              <p>Amount Tendered</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontWeight: "400",
                  color: "#0F0718",
                }}
              >
                {parseFloat(amount || 0).toFixed(pricePrecision)}
              </p>
            </Col>
          </Row>

          {/* Amount Received Row */}
          <Row
            style={{
              fontSize: "1em",
              width: "100%",
            }}
          >
            <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
              <p>Amount Received</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontWeight: "400",
                  color: "#0F0718",
                }}
              >
                {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
              </p>
            </Col>
          </Row>

          {/* Change Row */}
          <Row
            style={{
              fontSize: "1em",
              width: "100%",
            }}
          >
            <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
              <p>Change Due</p>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "right",
                justifyContent: "end",
              }}
            >
              <p
                style={{
                  textAlign: "right",
                  fontWeight: "400",
                  color: "#0F0718",
                }}
              >
                {cart.paid + parseFloat(amount || 0) - Math.abs(cart.total) > 0
                  ? (cart.paid + parseFloat(amount || 0) - Math.abs(Math.abs(cart.total) + (posConfig?.enableChangeRounding === "Y" ? Math.abs(overPayedAmount) : 0))).toFixed(
                      pricePrecision
                    )
                  : cart?.change <= 0
                    ? "0.00"
                    : cart?.change}
              </p>
            </Col>
          </Row>
        </div>
      ),
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      cancelButtonProps: {
        style: {
          borderRadius: "5px",
        },
      },
      okButtonProps: {
        style: {
          borderRadius: "5px",
        },
      },
    });
  });
};

export const handleDateSelect =
  ({
    setSelectedDate,
    setCalendarVisible,
    searchInputRef,
    cart,
    setCart,
    setSelectedProductForNotes,
    setNotesPopup,
    setIsInputFocused,
    calendarVisibleMap,
    setCalendarVisibleMap,
  }) =>
  (record) =>
  (date, dateString) => {
    let updatedCart;
    setSelectedDate(date);

    setCalendarVisible(false);
    if (searchInputRef?.current) {
      searchInputRef?.current.focus();
    }
    if (record !== null && cart.items.length > 0) {
      updatedCart = { ...cart };
      let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
      if (index >= 0) {
        updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
      }
      setCalendarVisibleMap((prev) => ({
        ...prev,
        [record.lineId]: !prev[record.lineId] || false,
      }));
    } else {
      updatedCart = {
        ...cart,
        deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
        deliveryDatePromised: (date && dateString) || "",
      };
    }
    setSelectedProductForNotes(null);
    setCart(updatedCart);
    setNotesPopup(false);
    setIsInputFocused(false);
    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || useAuthStore.getState().tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"),
      };
    } else if (updatedCart.items.length > 0 || useAuthStore.getState().tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
      };
    }
    if (updatedCart.description === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: "",
        orderStartTime: "",
      };
    }
    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
  };

export const calendarContent =
  ({ handleDateSelectFn, selectedDate }) =>
  (record) => <DatePicker showTime={{ format: "hh:mm A" }} format="DD-MM-YYYY hh:mm A" onChange={handleDateSelectFn(record)} value={selectedDate} style={{ width: 250 }} />;

export const parseTillAccessMeta = (tillData) => {
  let reconstructedObject;
  const rawtillAccessMeta = tillData?.tillAccess?.tillAccessMeta;
  if (rawtillAccessMeta) {
    const rawDataArray = tillData?.tillAccess?.tillAccessMeta;
    const printObject = rawDataArray.find((item) => item.key === "Print");
    const printObjectValue = printObject?.value;
    if (printObjectValue !== undefined) {
      const cleanedData = printObjectValue.replace(/[{}"]/g, "");

      const keyValuePairs = cleanedData.split(",");

      reconstructedObject = {};
      keyValuePairs.forEach((pair) => {
        if (pair.includes(":")) {
          const [key, value] = pair.split(":");

          if (key !== undefined && value !== undefined) {
            reconstructedObject[key.trim()] = value.trim();
          }
        }
      });
    } else {
      console.error("printObjectValue is undefined");
    }
  }
  return reconstructedObject;
};
